import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sm:flex gap-2 sm:gap-4 mt-4 sm:mt-6" }
const _hoisted_2 = { class: "sm:space-y-4 space-y-2 mx-auto" }
const _hoisted_3 = { class: "w-full sm:mt-0 mt-6" }
const _hoisted_4 = { class: "flex gap-2 sm:gap-4 max-w-fit ml-auto" }

import ImageLoading from '@/components/shared/ImageLoading.vue';
import { Button, Form, FormItem, Input, Select, Textarea, TreeSelect } from 'ant-design-vue';
import { capitalize, ref, watch } from 'vue';
import { Comic, ComicStatus, genres } from '@/model/comic';
import { CopyOutlined } from '@ant-design/icons-vue';
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComicInformation',
  props: {
    isLoading: { type: Boolean },
    comic: {},
    comicStatuses: {},
    onSubmit: { type: Function }
  },
  setup(__props: any) {

const props = __props;



const imageURL = ref('');

const comic = ref<Comic>({ ...props.comic });
watch(() => props.comic, initialize);

function mapSelect(texts: string[]) {
	return texts.map((text) => {
		return {
			value: text,
			title: text,
			label: capitalize(text),
			key: text
		};
	});
}

async function submit() {
	if (comic.value) {
		await props.onSubmit({ ...comic.value });
	}
}

function initialize() {
	comic.value = { ...props.comic };
	imageURL.value = props.comic.imageURL;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SpinnerLoading, { loading: _ctx.isLoading }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ImageLoading, {
            src: imageURL.value,
            previewable: true,
            "img-class": "!h-72 !w-72",
            "loading-class": "h-72 w-72 m-auto sm:m-0"
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Form), {
            layout: "horizontal",
            model: comic.value,
            onFinish: _cache[8] || (_cache[8] = ($event: any) => (submit()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FormItem), {
                label: "Image",
                name: "imageURL",
                "has-feedback": "",
                rules: [{ required: true, message: `Please enter ${comic.value.type} image url` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input).Group, { compact: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Input), {
                        value: comic.value.imageURL,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((comic.value.imageURL) = $event)),
                        class: "!w-[calc(100%-2rem)] !text-start",
                        placeholder: `Enter a ${comic.value.type} image url`
                      }, null, 8, ["value", "placeholder"]),
                      _createVNode(_unref(Button), {
                        onClick: _cache[1] || (_cache[1] = () => (imageURL.value = comic.value.imageURL))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(CopyOutlined))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["rules"]),
              _createVNode(_unref(FormItem), {
                label: "Title",
                name: "title",
                "has-feedback": "",
                rules: [{ required: true, message: `Please enter ${comic.value.type} title` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input), {
                    value: comic.value.title,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((comic.value.title) = $event)),
                    placeholder: `Enter a ${comic.value.type} title`,
                    disabled: !!comic.value.comicUUID,
                    class: "bg-white"
                  }, null, 8, ["value", "placeholder", "disabled"])
                ]),
                _: 1
              }, 8, ["rules"]),
              _createVNode(_unref(FormItem), {
                label: "Author",
                name: "author",
                "has-feedback": "",
                rules: [{ required: true, message: `Please enter ${comic.value.type} author` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input), {
                    value: comic.value.author,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((comic.value.author) = $event)),
                    placeholder: `Enter a ${comic.value.type} author`,
                    disabled: !!comic.value.comicUUID,
                    class: "bg-white"
                  }, null, 8, ["value", "placeholder", "disabled"])
                ]),
                _: 1
              }, 8, ["rules"]),
              _createVNode(_unref(FormItem), {
                label: "Genre",
                name: "genres",
                "has-feedback": "",
                rules: [{ required: true, message: `Please select ${comic.value.type} genre` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TreeSelect), {
                    value: comic.value.genres,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((comic.value.genres) = $event)),
                    style: {"width":"100%"},
                    "tree-data": mapSelect(_unref(genres)),
                    "tree-checkable": "",
                    class: "text-start",
                    placeholder: `Please select ${comic.value.type} genre`,
                    "tree-node-filter-prop": "label"
                  }, null, 8, ["value", "tree-data", "placeholder"])
                ]),
                _: 1
              }, 8, ["rules"]),
              _createVNode(_unref(FormItem), {
                label: "Status",
                name: "status",
                "has-feedback": "",
                rules: [{ required: true, message: `Please select ${comic.value.type} status` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Select), {
                    value: comic.value.status,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((comic.value.status) = $event)),
                    options: mapSelect(_ctx.comicStatuses),
                    placeholder: `Please select ${comic.value.type} status`,
                    class: "text-start"
                  }, null, 8, ["value", "options", "placeholder"])
                ]),
                _: 1
              }, 8, ["rules"]),
              _createVNode(_unref(FormItem), {
                label: "Description",
                name: "description",
                rules: [{ required: true, message: `Please enter ${comic.value.type} description` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Textarea), {
                    value: comic.value.description,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((comic.value.description) = $event)),
                    placeholder: `Enter a ${comic.value.type} description`,
                    autoSize: ""
                  }, null, 8, ["value", "placeholder"])
                ]),
                _: 1
              }, 8, ["rules"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(Button), {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (initialize()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Reset")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  "html-type": "submit",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})